import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, FolderOpen, Plus } from "lucide-react";
import { useAuth } from "@/auth/AuthProvider";
import PageHeader from "@/components/common/PageHeader";
import { AddKnowledgeSheet, KnowledgeBaseTab } from "@/components/knowledge-base";
import { Button } from "@/components/ui/button";
import { useAgentsList } from "@/hooks/agent";

const AllDocumentsPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data: agents = [] } = useAgentsList();
  const [uploadOpen, setUploadOpen] = useState(false);
  const [uploadSessionKey, setUploadSessionKey] = useState(0);

  const openUpload = () => {
    setUploadSessionKey((current) => current + 1);
    setUploadOpen(true);
  };

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#F9FAFC]">
      <div className="container mx-auto max-w-[1920px] px-4 py-8">
        <PageHeader
          title="All Documents"
          genieIcon="files"
          subtitle="Browse your shared library, then connect the same knowledge to one or more Genies."
          action={
            <Button
              onClick={openUpload}
              className="h-10 gap-2 bg-gradient-to-r from-genie-primary to-genie-secondary font-semibold text-white shadow-md shadow-genie-primary/20 hover:from-genie-primary-hover hover:to-genie-secondary"
            >
              <Plus className="h-4 w-4" />
              Add knowledge
            </Button>
          }
        />

        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
          <button
            type="button"
            onClick={() => navigate("/genie-hub/knowledge-base")}
            className="inline-flex items-center gap-2 text-sm font-medium text-gray-600 transition-colors hover:text-gray-900"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Genies
          </button>
          <div className="inline-flex items-center gap-2 rounded-full border border-genie-primary/20 bg-genie-primary/5 px-3 py-1.5 text-xs font-medium text-genie-primary">
            <FolderOpen className="h-4 w-4" />
            Select documents, then use Assign to Genie to share them.
          </div>
        </div>

        <KnowledgeBaseTab agents={agents} userId={user?.id} onRequestUpload={openUpload} />
      </div>

      <AddKnowledgeSheet
        isOpen={uploadOpen}
        onClose={() => setUploadOpen(false)}
        sessionKey={uploadSessionKey}
        availableAgents={agents}
      />
    </div>
  );
};

export default AllDocumentsPage;
